// In InvoicesList.js
import React, { useEffect, useState } from "react";
import DashTable from "./DashTable";
import SearchBox from "../../../Component/DigitalMarketing/SearchBox";
import { Col, Row } from "react-bootstrap";
import Pagination from "../../../Component/DigitalMarketing/Pagination";
import { useGetPatientListQuery } from "../../../Service/PatientList";
import { Change } from "../../../store/async-actions/digitalmarketing/header";
import { useDispatch } from "react-redux";
import Loader from "../../../Component/DigitalMarketing/Loader";

const PatientList = () => {
  const [searchValue, setSearchValue] = useState("");
  const [pagination, setPagination] = useState(1);
  const dispatch = useDispatch()
  const pagi = {
    pageNo: pagination,
    name: searchValue,
  };
  const { data: patientListData, refetch,isLoading } = useGetPatientListQuery(pagi, {
    refetchOnMountOrArgChange: true,
  });

  const onChangeSearch = (event) => {
    setSearchValue(event.target.value);
  };

  useEffect(() => {
    const data: any = {
      first: "Patient"
    };
    dispatch(Change(data));
  }, []);
  if (isLoading) {
    return <Loader loading={true}/>;
  }
  return (
    <div>
      <Row>
        <Col md={5}>
          <SearchBox value={searchValue} onChange={onChangeSearch} />
        </Col>
      </Row>

      <div className="row mt-4">
        <div className="col-12">
          <DashTable
            searchValue={searchValue}
            patientListData={patientListData?.data || []} // Pass data to DashTable
          />
        </div>
        <Pagination
          setPagination={setPagination}
          pagination={pagination}
          data={patientListData}
        />
      </div>
    </div>
  );
};

export default PatientList;
